import { Link } from 'react-router-dom';
import { BlogPost } from '@/lib/supabase';
import { TrendingUp } from 'lucide-react';

interface SidebarTrendingProps {
  posts: BlogPost[];
}

export function SidebarTrending({ posts }: SidebarTrendingProps) {
  if (!posts || posts.length === 0) return null;

  return (
    <div className="bg-white p-6 rounded-2xl border border-slate-200 shadow-sm">
      <h3 className="font-bold text-slate-900 mb-6 flex items-center gap-2 text-lg">
        <TrendingUp className="w-5 h-5 text-red-500" />
        Lo más leído
      </h3>
      
      <div className="space-y-6">
        {posts.map((post, index) => (
          <Link 
            key={post.id} 
            to={`/blog/${post.slug}`}
            className="group flex gap-4 items-start"
          >
            <span className="text-3xl font-black text-slate-200 leading-none group-hover:text-blue-200 transition-colors">
              {index + 1}
            </span>
            <div>
              <h4 className="font-bold text-slate-900 text-sm leading-snug mb-1 group-hover:text-blue-600 transition-colors line-clamp-2">
                {post.title}
              </h4>
              <span className="text-xs text-slate-500">
                {new Date(post.published_at || post.created_at).toLocaleDateString()}
              </span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
